
// @ts-nocheck

import {defineComponent} from "vue";
import TableSpinner from "@shared/components/layout/table-spinner.component.vue";
import PrepaidPackagesTable from "@shared/components/lk/prepaid-packages-table.component.vue";


export default defineComponent({
  name: "AdminAllServiceTemplatesView",
  components: {
    PrepaidPackagesTable, TableSpinner
  },
  mounted() {
    this.loading = true
    this.axios.get("/finance/prepaidPackages")
        .then(resp => {
          this.packages = resp.data.packages
          this.loading = false
        })
  },

  data() {
    return {
      loading: false,
      packages: []
    }
  }
})

